import React, { ReactNode, useEffect, useRef, useState } from 'react';
import useOnClickOutside from '../../hooks/useOnClickOutside';

interface ModalProps {
  children?: ReactNode;
  className?: string;
  open: boolean;
  onClose?(): void;
  onCallEndAnimate?(): void;
}

export default function Modal({
  children,
  className,
  open,
  onClose,
  onCallEndAnimate
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState(open);
  const handleClickOutside = () => {
    document
      .getElementsByTagName('body')[0]
      .classList.remove('overflow-hidden-body');

    if (onClose) {
      onClose();
      document
        .getElementsByTagName('body')[0]
        .classList.remove('overflow-hidden-body');
    }
  };

  useOnClickOutside(modalRef, (e) => {
    const target = e.target as HTMLElement;
    const overlayPortal = document.querySelector(
      '#overlay-portal'
    ) as HTMLDivElement;
    if (overlayPortal && overlayPortal.contains(target)) {
      return;
    }
    handleClickOutside();
  });

  useEffect(() => {
    if (open) {
      setIsOpen(open);
      document
        .getElementsByTagName('body')[0]
        .classList.add('overflow-hidden-body');
    } else {
      document
        .getElementsByTagName('body')[0]
        .classList.remove('overflow-hidden-body');
    }

    return document.body?.classList?.remove?.('overflow-hidden-body');
  }, [open]);

  return open || isOpen ? (
    <div
      style={{ zIndex: 199 }}
      className={
        'fixed inset-0 flex overflow-y-auto bg-black bg-opacity-30 py-8 px-8 smx:px-2 smx:py-4' +
        ` ${open ? 'animate-opacityin' : 'animate-opacityout'}`
      }>
      <div
        onAnimationEnd={() => {
          if (modalRef && modalRef.current) {
            if (!modalRef.current.className.includes('animate-modalfadein')) {
              setIsOpen(false);
              if (onCallEndAnimate) {
                onCallEndAnimate();
              }
            }
          }
        }}
        ref={modalRef}
        className={
          `${className ? className : ''}` +
          ` ${open ? 'animate-modalfadein' : 'animate-modalfadeout'}`
        }>
        {children}
      </div>
    </div>
  ) : null;
}
